<mat-toolbar color="accent"
             *ngIf="service?.breadcrumb?.length"
             [ngClass]="{'breadcrumb--new-active': !!createAction.text, 'breadcrumb--hidden': !root.canISeeBreadcrumb}"
             class="breadcrumb">
    <mat-toolbar-row class="breadcrumb__row">
        <div class="breadcrumb__path">
            <app-form-button [click]="open.bind(this)"
                             icon="menu"
                             *ngIf="isLogged"
                             class="breadcrumb__menu"
                             theme="icon"
                             color="primary"
                             tooltip="menu.breadcrumb.actions.menu.text"
                             text="menu.breadcrumb.actions.menu.text">
            </app-form-button>

            <img src="assets/imgs/visual-identity/logo-profile.png" class="breadcrumb__img" alt="logo" *ngIf="!isLogged">
            <ol class="breadcrumb__list">
                <li *ngFor="let item of service.breadcrumb; let last = last;" class="breadcrumb__item">
                    <a [ngClass]="{'breadcrumb__link--disabled': last}"
                       [attr.aria-disabled]="last"
                       class="breadcrumb__link"
                       [tabindex]="last ? -1 : 0"
                       [routerLink]="item.url"
                       target="_self"
                       rel="noopener">
                        {{ item.label | translate }}
                    </a>
                    <mat-icon class="breadcrumb__icon" aria-hidden="true" *ngIf="!last">navigate_next</mat-icon>
                </li>
            </ol>
        </div>
        <div class="breadcrumb__actions">
            <app-local-actions where="breadcrumb"></app-local-actions>
        </div>
    </mat-toolbar-row>
    <mat-toolbar-row class="breadcrumb__new">
        <app-form-fab *ngIf="!!createAction.text"
                      [href]="createAction.href"
                      [icon]="createAction.icon"
                      [text]="createAction.text"
                      (click)="createAction?.click && createAction.click()">
        </app-form-fab>
    </mat-toolbar-row>
</mat-toolbar>